<script setup lang="ts">
import { UITextMdMedium } from '@gohighlevel/ghl-ui'
import { Send01Icon } from '@gohighlevel/ghl-icons/24/outline'
import { UITag } from '@gohighlevel/ghl-ui'
import { i18nLocale, useVueI18n } from '../../../locales'
import { SendDocumentsContractAction } from '../../../types/components/send-doc-modal.schema'
import { formatDateWithLocale } from '../../../utils'

defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
})
const t = useVueI18n()
</script>

<template>
  <div class="flex items-center justify-between">
    <UITextMdMedium class="text-base font-semibold">
      <span v-if="data?.metaData?.name" class="text-gray-800">
        {{ data.metaData.name }}
        <template v-if="data?.metaData?.email"
          >({{ data.metaData.email }})</template
        >
      </span>
      <span class="text-gray-800" v-else>{{ data.metaData.email }}</span>
      <span class="font-normal text-gray-500 ml-1">
        {{ t('proposalsList.eventLogs.sentTitle') }}
      </span>
      <span class="text-gray-800 ml-1">
        <template v-if="data?.metaData?.sentTo?.name">{{
          data.metaData.sentTo.name
        }}</template>
        <span
          v-if="data?.metaData?.sentTo?.name && data?.metaData?.sentTo?.email"
          class="ml-1"
          >{{ data?.metaData?.sentTo?.email }}</span
        >
        <template v-else>{{ data?.metaData?.sentTo?.email }}</template>
      </span>
      <span class="font-normal text-gray-500 ml-1">
        {{
          (() => {
            const medium = data?.metaData?.sentTo?.medium
            switch (medium) {
              case SendDocumentsContractAction.EMAIL:
                return t('proposalsList.eventLogs.sentViaEmail')
              case SendDocumentsContractAction.SMS:
                return t('proposalsList.eventLogs.sentViaSms')
              case SendDocumentsContractAction.SMS_AND_EMAIL:
                return t(
                  'proposalsList.eventLogs.sentViaEmailAndSms'
                )
              case SendDocumentsContractAction.LINK:
                return t('proposalsList.eventLogs.sentViaLink')
              default:
                return t('proposalsList.eventLogs.sentViaLink')
            }
          })()
        }}
      </span>
    </UITextMdMedium>
  </div>
  <div class="flex justify-between items-end mt-4">
    <p class="text-sm text-gray-500">
      {{
        formatDateWithLocale(
          data.createdAt,
          i18nLocale,
          'MMMM DD, YYYY'
        )
      }}
    </p>
    <UITag type="warning" size="small" class="text-[8px] sent-event">
      <template #icon> <Send01Icon class="w-4 h-4 send-icon" /></template>
      {{ t('proposalsList.eventLogs.sent') }}
    </UITag>
  </div>
</template>

<style scoped lang="scss">
.sent-event {
  --n-text-color: rgb(194 65 12) !important;
  --n-color: rgb(255 247 237) !important;
  --n-border: 0px !important;
}
.send-icon {
  color: rgb(249 115 22) !important;
}
</style>
